import { React, useState } from "react";
import { Steps } from "./Steps/Steps";
export const HowToPlay = () => {
  const [termAndConditionModalVisible, setTermAndConditionModalVisible] =
    useState(false);

  const handleTermAndConditionModal = (e) => {
    e.preventDefault();
    setTermAndConditionModalVisible(true);
  };

  return (
    <>
      <div className="howToPlayContainer" id="howToPlay">
        <div className="howToPlayInnerLeftContainer"></div>
        <div className="howToPlayInnerRightContainer"></div>
        <div className="container">
          <div className="howToPlayHeading">How to Play?</div>
          <div className="steps mt-5">
            <div>
              <Steps
                step={1}
                heading={"Participate"}
                text={
                  "Get in the game! Participate, answer & get your ₹100 coupon!"
                }
              />
            </div>
            <div>
              <Steps
                step={2}
                heading={"Answer"}
                text={
                  "Answer correctly & win extra for every right answer—more answers, more rewards!"
                }
              />
            </div>
            <div>
              <Steps
                step={3}
                heading={"Win"}
                text={
                  "Get all 3 answers right & get exciting discount coupons —easy win, guaranteed rewards!"
                }
              />
            </div>
          </div>
          <div className="tandcWrapper">
            <a href="#" onClick={handleTermAndConditionModal}>
              Check Terms & Conditions
            </a>
          </div>
        </div>
      </div>
      <div
        className={`backdrop ${termAndConditionModalVisible ? "show" : "fade"}`}
      ></div>
      <div
        className={`modal championsTrophyTermConditionModal ${
          termAndConditionModalVisible ? "show" : "fade"
        }`}
        id="exampleModal"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header-custom">
              <h5 className="modal-title" id="exampleModalLabel">
                Terms & Conditions
              </h5>
              <button
                type="button"
                className="close-custom"
                data-dismiss="modal"
                aria-label="Close"
              >
                <span
                  aria-hidden="true"
                  onClick={() => setTermAndConditionModalVisible(false)}
                >
                  &times;
                </span>
              </button>
            </div>
            <div className="modal-body">
              <div className="termConditions">
                <ul>
                  <li>
                    These terms and conditions (T&C) shall govern the Champions
                    Trophy Quiz Game (“Quiz”)conducted as part of the Champions
                    Trophy 2025 Offer (hereinafter referred to as
                    “Offer/Contest”)provided Dish Infra Services Private Limited
                    (hereinafter referred to as ‘Company’) for its VZY OTT
                    subscribers as specified during the ‘ICC Champions Trophy
                    2025’ cricket tournament.{" "}
                  </li>
                  <li>
                    The Offer shall be available during the period from 18th
                    February 2025 onwards till the end of the ICC Champions
                    Trophy tournament (“Term”) and is limited to existing
                    registered VZY users who have never purchased a VZY
                    subscription plan and erstwhile VZY subscribers who are
                    currently de-active for greater than 7 days as on the date
                    of their participation in the Quiz/Offer (hereinafter,
                    referred to as ‘Subscribers’).{" "}
                  </li>
                  <li>
                    The employees of the Company and their family members,
                    Company’s associate companies, trade partners, advertising
                    and promotional agencies and auditors / executing agencies
                    are not entitled to participate in the Contest. Minors are
                    not allowed to participate in this Contest.{" "}
                  </li>
                  <li>
                    The participants (hereinafter referred to as
                    Participants/You/Your) has/have read and understood these
                    T&C stated herein. You hereby agree and confirm that your
                    participation in the Offer is subject to your unconditional
                    acceptance to comply with the T&C stated herein.{" "}
                  </li>
                  <li>
                    No purchase or payment is required to participate in this
                    Quiz/Offer. Participation shall be solely on voluntary
                    basis.
                  </li>
                  <li>
                    Even participation (only through the registered mobile
                    number) entitles a Participant in a day to win discount
                    coupon worth INR 100 only (One Hundred only) (“vzy
                    Coupons”). Every correct answer in the Quiz entitles a
                    Participant to win discount coupon worth INR 150 only (One
                    Hundred & Fifty only) (“vzy Coupons”) .Maximum coupon value
                    a winner can win is Rs.550 only (Rs.Five Hundred & Fifty
                    only).{" "}
                  </li>
                  <li>
                    Participant will have to answer three quiz questions (in
                    matches where India is playing) and one quiz question (in
                    matches where India is not playing). The Participant can
                    answer the questions by clicking on the link provided
                    through SMS or WhatsApp on the registered Mobile Number. A
                    Participant cannot change the answer once submitted.{" "}
                  </li>
                  <li>
                    Quiz will start 24 to 48 hours before the schedule start of
                    the respective match.{" "}
                  </li>
                  <li>
                    SMS would be sent out to the participant and winners
                    informing them of their prizes and their prizes/coupons code
                    shall be provided via SMS on the registered mobile number.
                  </li>
                  <li>
                    The discount coupons can be availed only for purchasing VZY
                    Max by logging to www.vzy.one or on the VZY App. The
                    discount coupon/s can be availed only once. Only one
                    discount coupon can be redeemed for purchasing the VZY Max
                    subscription plan by following the relevant registration
                    process of subscription. The VZY Max plan once purchased by
                    the Subscriber under this offer will be on auto-renewal
                    unless opted out as per the Company policy. Balance coupon/s
                    can be redeemed to recharge VZY Max plan in future by
                    registered users or new user. Validity of the coupon will be
                    06(Six) months from date on which the final match of the ICC
                    Champions Trophy 2025 will be played.
                  </li>
                  <li>
                    By participating in the Contest, the Participant gives the
                    right to the Company to use and publish their names and
                    images on its website and other promotional materials as the
                    Company may deem fit.{" "}
                  </li>
                  <li>
                    Company may substitute or change the rewards under the Offer
                    at any time without notice to Participants. The Winner shall
                    not be entitled to substitute the rewards for other item(s)
                    or exchange for cash. Rewards shall be
                    non-transferable.{" "}
                  </li>
                  <li>
                    By participating in the Contest, each Participant agrees
                    that Participant’s name, address, telephone numbers, e-mail
                    identities or any other information that is provided by the
                    Participant (“Personal Information”) may be shared by the
                    Company with others associated with and/or assisting in
                    organizing and administering the Contest, and to send to the
                    Participant promotional information pertaining to the
                    Company, in future.{" "}
                  </li>
                  <li>
                    All taxes, levies and duties due and owing under applicable
                    and statutory laws in connection with all the winnings, if
                    any, are the sole responsibility of the Winner.{" "}
                  </li>
                  <li>
                    In the event of a death of the Winner, no claim from the
                    nominees or legal heirs of the Winner shall be entertained
                    by the Company for receiving the rewards.{" "}
                  </li>
                  <li>
                    Decision of the Company will be final and binding with
                    regard to the Contest, declaration of Winner and Prize and
                    no correspondence, objection, complaints, etc. from any
                    Participant or any third party shall be entertained in this
                    regard.{" "}
                  </li>
                  <li>
                    This Offer cannot be clubbed with any of other
                    contest/offers of the Company that are running
                    simultaneously.{" "}
                  </li>
                  <li>The Offer is subject to force majeure conditions. </li>
                  <li>
                    The Company reserves the right to change/modify/or withdraw
                    the Offer anytime at its sole discretion and without giving
                    any prior notice to the Participants. The Company reserves
                    the right to modify the terms and conditions of the Offer
                    without any prior notice to any Participants or third party.
                  </li>
                  <li>
                    Participants shall be solely responsible for any costs and
                    expenses incurred towards internet connection charges,
                    e-mail transmission charges, data transfer (send/receive)
                    charges, mobile connection charges or other incidental costs
                    or expenses as may be applicable, inclusive or exclusive of
                    any other service charges, applicable taxes, levies, duties,
                    cess, etc. depending upon the service provider.{" "}
                  </li>
                  <li>
                    Company assumes no responsibility for any error, omission,
                    interruption, deletion, defect, delay in operation or
                    transmission, communications line-failure, theft or
                    destruction or unauthorized access to, or alteration of,
                    entries.{" "}
                  </li>
                  <li>
                    This offer is available for non- commercial usage only.{" "}
                  </li>
                  <li>
                    This Offer is in no way sponsored, endorsed or administered
                    by, or associated with Facebook/Twitter/ or any other media
                    on which the Offer may be communicated or published.{" "}
                  </li>
                  <li>
                    The images, if any used in the Offer belongs to the
                    respective person whose images are so used in the
                    Contest.{" "}
                  </li>
                  <li>
                    Company does not make any commitment, express or implied, to
                    respond to any feedback, suggestion and, or, queries of the
                    Participants or furnish any reason or explanation for
                    inclusion and/or exclusion of any particular submission of
                    the entry of a Participants at any stage of the
                    Contest.{" "}
                  </li>
                  <li>
                    This Offer is not valid wherever prohibited by Law of any
                    State and the Subscribers from such States shall not be
                    eligible for participation in the Contest. The Offer shall
                    be subject to all applicable mandatory national and state
                    laws.{" "}
                  </li>
                  <li>
                    All decisions with respect to the Offer shall be at the sole
                    discretion of Company. In the event of any fault,
                    misunderstanding or dispute concerning any part of the
                    Contest, the decision of Company shall be final.{" "}
                  </li>
                  <li>
                    All disputes are subject to the courts situated at Delhi
                    only.
                  </li>
                  <li>
                    This document is an electronic record in terms of
                    Information Technology Act, 2000 and the Rules thereunder as
                    applicable and the amended provisions pertaining to
                    electronic records in various statutes as amended by the
                    Information Technology Act, 2000.{" "}
                  </li>
                  <li>
                    This electronic record is generated by a computer system and
                    does not require any physical or digital signatures.{" "}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
